import { render, staticRenderFns } from "./setCollectAccount.vue?vue&type=template&id=e116496a"
import script from "./setCollectAccount.vue?vue&type=script&lang=js"
export * from "./setCollectAccount.vue?vue&type=script&lang=js"
import style0 from "./setCollectAccount.vue?vue&type=style&index=0&id=e116496a&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e116496a')) {
      api.createRecord('e116496a', component.options)
    } else {
      api.reload('e116496a', component.options)
    }
    module.hot.accept("./setCollectAccount.vue?vue&type=template&id=e116496a", function () {
      api.rerender('e116496a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/setCollectAccountByQuick/setCollectAccount.vue"
export default component.exports